import { render, staticRenderFns } from "./questionSearch.vue?vue&type=template&id=1e2ae4c4&scoped=true&"
import script from "./questionSearch.vue?vue&type=script&lang=js&"
export * from "./questionSearch.vue?vue&type=script&lang=js&"
import style0 from "./questionSearch.vue?vue&type=style&index=0&id=1e2ae4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ae4c4",
  null
  
)

export default component.exports